export const MelayuTraditionalCeremonies = [
  {
    name: "Tari Senandung Sarawak",
    img_src: "https://66.media.tumblr.com/fbcfdfc1c8e4e22d4fe0cdfba976470a/bf1d594385396fcb-78/s540x810/c49cc7f50f23441d4b93964c1b5957dbf20cad23.png",
    sub_img: "https://66.media.tumblr.com/fbcfdfc1c8e4e22d4fe0cdfba976470a/bf1d594385396fcb-78/s540x810/c49cc7f50f23441d4b93964c1b5957dbf20cad23.png",
    description: "Tari Senandung Sarawak or was known as Dayang Sari was a traditional Malay dance performed only by women in weddings or festivities. “Dayang” is a title given to women and “Sari” is the name of an acclaimed female figure. During performance,  dancers would be seen wearing the traditional Baju Kurung, the Kain Tudung Kerengkam on their heads and a Songket draped on their shoulders.",
    url: "Tari-Senandung-Sarawak"
  },
  
  {
    name: "Zapin Sebat",
    img_src: "https://66.media.tumblr.com/d237bde7641f38738d91de9802007de4/a8a7d8451aa9da6f-8a/s400x600/8573d94071a3ae9780af2fb5e204b918046f6a9e.png",
    sub_img: "https://66.media.tumblr.com/d237bde7641f38738d91de9802007de4/a8a7d8451aa9da6f-8a/s400x600/8573d94071a3ae9780af2fb5e204b918046f6a9e.png",
    description: "Zapin Sebat is a dance originated from Kampung Sebat located in a small province called Sematan, Lundu. Zapin Sebat consists of 11 choreographic moves known as “sembah mula”, “mula langkah”, “mula langkah pusing”, “mabuk kemenyan”, “langkah tiga”, “tumpah madu”, “bemain gelombang”, “meniti Gigi air”, “gigi lembadak”, “berdayung”, and “langkah sebaya”. The dance itself has a billowing and controlled sense to it, representing the calming ocean waves. Back in the days, Zapin Sebat was usually performed the night before a wedding or “Malam Berinai” but today, it is also performed during official settings.",
    url: "Zapin-Sebat"
  },
  
  {
    name: "Zapin Sindang",
    img_src: "https://66.media.tumblr.com/a87183d1f16281ee4ef51c89900a838a/a8a7d8451aa9da6f-bb/s540x810/c39e1b95ad55300375f0df2d0b647795c273cf82.png",
    sub_img: "https://66.media.tumblr.com/a87183d1f16281ee4ef51c89900a838a/a8a7d8451aa9da6f-bb/s540x810/c39e1b95ad55300375f0df2d0b647795c273cf82.png",
    description: "Zapin Sindang is a dance originated from Kampung Sindang, Samarahan. The dance was usually performed during “Malam Berinai” before the wedding. The dance was inspired from the Arabs that came into Sarawak through Sambas and Serasan Kalimantan, Indonesia. The founder of this dance, Encik Nawi believed that the dance helped in spreading the teachings of Islam in Borneo. Hence, in the dance, there is a restrictive physical and eye contact element between the men and women.",
    url: "Zapin-Sindang"
  },
  
  {
    name: "Joget Serampang Laut/Baru",
    img_src:"https://66.media.tumblr.com/89a0b56195e7f6ef426352694a1808e9/bf1d594385396fcb-1e/s540x810/7783259e26527b1664fe881195676e05edfd91c6.png",
    sub_img:"https://66.media.tumblr.com/89a0b56195e7f6ef426352694a1808e9/bf1d594385396fcb-1e/s540x810/7783259e26527b1664fe881195676e05edfd91c6.png",
    description:"Joget Serampang Laut/Baru is a traditional dance that tells a story of a young fella’s journey in finding his love interest, from courting to marriage. This dance became a way to teach young generations the customs of courtship. The dance is usually performed during a wedding or festivities. In the eary days, Joget Serampang Baru was only performed by men. This was because back then, women were strictly forbidden to expose themselves in public in such manner, i.e. dancing. However, ada the world progresses, today, it can be seen that this dance is usually performed in pairs of opposing gender.  ",
    url: "Joget-Serampang-Laut-Baru"
  },
  
  {
    name: "Nopeng Kinek / Tandak Melayu Sarawak",
    img_src:"https://66.media.tumblr.com/a5423359f47eec72dae1b3642744d342/e45a3fa89d0c741a-54/s250x400/c3702dadbf3a2613eb7a831e9152e18333b8631a.png",
    sub_img:"https://66.media.tumblr.com/a5423359f47eec72dae1b3642744d342/e45a3fa89d0c741a-54/s250x400/c3702dadbf3a2613eb7a831e9152e18333b8631a.png",
    description: "Nopeng Kinek is a dance inspired from the Malay community’s favourite activity, “bergendang” or Nopeng. The dance is usually performed in a wedding or official ceremonies and stage performances. “Nopeng” essentially means masquerade. Back in the days, when dancing Malay men would cover their face and upper body with batik or “kain pelikat”. Their partner would also had their ‘mask’ on in any form they preferred. “Kinek”, on the other hand, translates to the word now. To “Nopeng” or “Bermukun” is an activity is still being practiced widely by the Malay community in Sarawak. This activity is usually done on the eve of a wedding and would lasted all night",
    url:"Nopeng-Kinek"
  },
  
  {
    name: "Makan Tolak Bala",
    img_src:"",
    sub_img:"",
    description:"‘Tolak Bala’ in literal translation is to repel against misfortune. The villagers will hold makan tolak bala' or ‘makan selamat’ if there was a disaster in the village. For example the discovery of a supernatural being in a village or a burning house.",
    url:"Makan-Tolak-Bala"
  },
  
  {
    name: "Bertangas Kemenyan",
    img_src:"https://66.media.tumblr.com/4fc98867f3e42a188667c1a46d804194/bf1d594385396fcb-54/s540x810/55f7489e452b0bea48d332b74ecec4cfb30250d1.png",
    sub_img:"https://66.media.tumblr.com/4fc98867f3e42a188667c1a46d804194/bf1d594385396fcb-54/s540x810/55f7489e452b0bea48d332b74ecec4cfb30250d1.png",
    description:"Bertangas Kemenyan is a traditional way to cure a person with skin issues. A patient would usually had to be under a cover with the burning ‘kemenyan’ and let the smoke steam the affected body surface. ",
    url:"Betangas-Kemenyan"
  },
  
  {
    name:"Melangkah Bendol",
    img_src:"",
    sub_img:"",
    description:"Melangkah Bendol is when a younger sibling in the family is getting married before the older ones. In this situation, the groom would have to present the bride’s older sisters or brothers with gifts. ",
    url:"Melangkah-Bendol"
  },
  
  {
    name: "Upacara Mendirikan Tiang Rumah",
    img_src:"",
    sub_img:"",
    description:"Anyone who wanted to build a new house, had to set up the main pillar of the house. In the Mendirikan Tiang Ceremony, the main pillar of  the house should be erected during the morning prayer call (Azan Subuh) . It is to ward against bad spirits or demons. Then, the main pole would be tied with red, yellow and green straps. However, this belief does not cover the entire Malay community in Sarawak. Some of the communities that still believes and performs this ritual is are seen in Maludam, Simunjan. ",
    url:"Upacara-Mendirikan-Tiang-Rumah"
  },
  
  {
    name: "Menutup Tiang Rumah yang Belum Beratap",
    img_src:"",
    sub_img:"",
    description:"When a newly built house was made but has yet to have roof installed. The ceremony called Menutup Tiang Rumah of the unroofed home would be done during full moon. It is to ward the newly established home against misfortunes. There are Malays who would cover every pole using plastic or barrels of paint.",
    url:"Menutup-Tiang-Rumah-yang-Belum-Beratap"
  },
  
  {
    name: "Upacara Sekapur Sireh",
    img_src:"",
    sub_img:"",
    description:"This ceremony will be performed for newly married couples. The pair will throw a shovel to the riverbank or the sea with the intention of shunning away distress. ",
    url:"upacara-sekapur-sireh"
  },
  
  {
    name:"Cukur Jambul Bayi",
    img_src:"",
    sub_img:"",
    description:"The Cukur Jambul ceremony is a custom tradition that is still been widely performed within the Malay community in Sarawak. It is to welcome the birth of a new family member. During the Cukur Jambul ceremony, elders would snip a few strands of the newborn hair while they are reciting ‘zikr’. ",
    url:"cukur-jambul-bayi"
  },
  
  {
    name: "Upacara Bermukun",
    img_src:"",
    sub_img:"",
    description:"The ceremony of Bermukun often performed during weddings. During the eremony, there will be people playing the Gendang while singing. The guests or spectators would usually gather around dancing.",
    url:"upacara-bermukun"
  },
  
  {
    name: "Upacara Bertekul / Merisik",
    img_src:"",
    sub_img:"",
    description:"The Bertekul or Merisik ceremony is when a man’s family would go to the woman's house to ask for her hand-in-marriage from her parents. Usually the man’s family would already have the  engagement ring in ready. If the woman’s parents accept the proposal only then that the ring would be slid onto the woman’s finger. ",
    ur:"upacara-bertekul-merisik"
  },
  
  {
    name:"Tradisi Bertuntung",
    img_src:"https://66.media.tumblr.com/7ca627417011b577188264bef322d53d/bf1d594385396fcb-46/s540x810/dea9e7d978a6e7418ec4a8d59a0be5cea7bb7095.png",
    sub_img:"https://66.media.tumblr.com/7ca627417011b577188264bef322d53d/bf1d594385396fcb-46/s540x810/dea9e7d978a6e7418ec4a8d59a0be5cea7bb7095.png",
    description:"Bertuntung is a traditional ceremony in Sarawak that started from the beginning on ‘Malam 7 Likur’ or the last 7 days of Ramadan and ends on the 7th day after Eid. Bertuntung is basically when people lights up oil lamps and decorate their home compounds with them. Nowadays, this tradition deteriorates due to limited sources to purchase gasoline from.",
    url:"tradisi-bertuntung"
  },
  
  {
    name:"Makan Nasi Temuan",
    img_src:"",
    sub_img:"",
    description:"Makan Nasi Temuan is one of the tradition still practiced by the Malays in Sarawak. It is to represent a newly-wed’s first dish. There are three common components for the Nasi Temuan: Salt, sugar, and rice each with its own symbolism. The salt represents the ups and downs in life that the couple may encounter throughout their marriage. Sugar represents the bliss of matrimony that should exists between the two. Rice symbolises the first sustenance that the couple shall share for the rest of their lives. Makan Nasi Temuan would be a challenge for the newly-weds which consists of 3 rounds. Those who reached for the specific ingredients first and feeds it to their other half wins. It is said that if the bride wins the challenge, the wife will have an upper-hand in the marriage and their first child would be a girl and vice versa. ",
    url:"makan-nasi-temuan"
  },
  ];
  